exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__yr-d1{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__38N33{display:none!important}}@media (max-width:79.9rem){.style_hide-md__NZxWF{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2MtkH{display:none!important}}.style_container__17bog{margin:.875rem 1rem 0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__yr-d1",
	"hideSm": "style_hide-sm__yr-d1",
	"visible-sm": "style_visible-sm__38N33",
	"visibleSm": "style_visible-sm__38N33",
	"hide-md": "style_hide-md__NZxWF",
	"hideMd": "style_hide-md__NZxWF",
	"visible-md": "style_visible-md__2MtkH",
	"visibleMd": "style_visible-md__2MtkH",
	"container": "style_container__17bog"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/tasks/TaskLayout/style.less
// module id = 1579
// module chunks = 8